<template>
    <div class="total-ranking-card" :class="{ 'flex-row items-center': $store.getters.isMobile }">
        <div class="upper flex-row items-center">
            <div class="flex-wrap m-r-12 p-relative">
                <div class="img-profile" v-lazy:background-image="user.photo_url" />
                <i
                    class="zmdi zmdi-star-circle"
                    :class="{ 'c-gold': rank === 1, 'c-silver': rank === 2, 'c-bronze': rank === 3 }"
                />
            </div>
            <div>
                <div class="profile flex-row m-b-10">
                    <div
                        class="rank flex-wrap m-r-8"
                        :class="{ 'c-gold': rank === 1, 'c-silver': rank === 2, 'c-bronze': rank === 3 }"
                        v-html="`${rank}위`"
                    />
                    <div v-if="!hourlyPay" class="nickname" v-html="user.nickname" />
                </div>
                <div v-if="!hourlyPay" class="stat flex-row items-center">
                    <div class="key flex-wrap m-r-8" v-html="statKey" />
                    <div class="value" v-html="statValue" />
                </div>
                <div v-else class="c-text-dark" v-html="user.nickname" />
            </div>
        </div>
        <div v-if="hourlyPay" class="two-stats flex-row">
            <div>
                <div class="title" v-html="$translate('TOTAL_RANKING_MATCHING_PER_HOUR')" />
                <div class="value" v-html="statValue" />
            </div>
            <div>
                <div class="title" v-html="$translate('TOTAL_RANKING_MATCHING_HOURLY_PAY')" />
                <div class="value c-text" v-html="hourlyPay" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TotalRankingCard',
    props: ['rank', 'user', 'statKey', 'statValue', 'hourlyPay'],
}
</script>
